<template>
  <base-dialog :value="isShown"
               :title="title"
               :text="description"
               :is-primary-button-busy="isBusyConfirming"
               @cancel="handleCancel"
  >
    <template v-if="hasSlotIcon" #icon>
      <slot name="icon" />
    </template>

    <template #confirm-button>
      <busy-button class="flex items-center justify-center w-full ml-4"
                   :id="busyButtonId"
                   :is-loading="isBusyConfirming"
                   :variant="confirmButtonVariant"
                   @click="$emit('confirm', item)"
      >
        <div>{{ confirmText }}</div>
      </busy-button>
    </template>
  </base-dialog>
</template>

<script>
import BusyButton from '@/components/common/BusyButton'
import busyButtonsModule from '@/store/modules/busy-buttons.module'

export default {
  name: 'ConfirmDialog',

  components: {
    BusyButton
  },

  props: {
    isShown: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    confirmText: {
      type: String,
      required: true
    },
    confirmButtonVariant: {
      type: String,
      default: 'bordered'
    },
    busyButtonId: {
      type: String,
      required: true
    }
  },

  computed: {
    isBusyConfirming() {
      return busyButtonsModule.isButtonBusy(this.busyButtonId)
    },
    hasSlotIcon() {
      return !!this.$slots?.icon
    }
  },

  methods: {
    handleCancel() {
      this.$emit('cancel')
    }
  }
}
</script>
